import React, { useMemo } from "react";
import { EXTENSION_TO_FILE_TYPE_GROUP } from "@common/constants/financial-documents";
import { FiltersTypes } from "@common/types/filters/general";
import { formatFilterLabelText } from "./formatFilterLabel";

interface Props {
    filters: Pick<FiltersTypes, "fileExtensions">;
}

export const DocumentTypeFilterLabel: React.FC<Props> = ({ filters }) => {
    const extensions = filters.fileExtensions;

    const groupLabels = useMemo(() => {
        if (!extensions || extensions.length === 0) {
            return [];
        }

        const seen = new Set<string>();
        return extensions.reduce<string[]>((labels, ext) => {
            const label =
                EXTENSION_TO_FILE_TYPE_GROUP[ext] ?? ext.toUpperCase();
            if (!seen.has(label)) {
                seen.add(label);
                labels.push(label);
            }
            return labels;
        }, []);
    }, [extensions]);

    if (groupLabels.length === 0) {
        return null;
    }

    return <span>{formatFilterLabelText(groupLabels, "Types")}</span>;
};
